// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

import Addition from "../../components/ClassTwo/NumberMath/Addition";
import DataHandling from "../../components/ClassTwo/NumberMath/DataHandling";
import Division from "../../components/ClassTwo/NumberMath/Division";
import GreaterLessThan from "../../components/ClassTwo/NumberMath/GreaterLessThan";
import Money from "../../components/ClassTwo/NumberMath/Money";
import Multiplication from "../../components/ClassTwo/NumberMath/Multiplication";
import Patterns from "../../components/ClassTwo/NumberMath/Patterns";
import Subtraction from "../../components/ClassTwo/NumberMath/Substraction";
import AdditionMenu from "./Addition";
import SubstractionMenu from "./Subtraction";
import MultiplicationMenu from "./Multiplication";
import DivisionMenu from "./Division";
import GreaterLessThanMenu from "./GreaterLessThan";
import PatternMenu from "./Patterns";
import MoneyMenu from "./Money";
import DataHandlingMenu from "./DataHandling";

const topics: MenuItem[] = [
    { url: "/class-two/number-math/addition", title: "Addition", component: Addition, subMenu: AdditionMenu },
    { url: "/class-two/number-math/substraction", title: "Subtraction", component: Subtraction, subMenu: SubstractionMenu },
    { url: "/class-two/number-math/multiplication", title: "Multiplication", component: Multiplication, subMenu: MultiplicationMenu },
    { url: "/class-two/number-math/division", title: "Division", component: Division, subMenu: DivisionMenu },
    { url: "/class-two/number-math/greater-less-than", title: "> or < or =", component: GreaterLessThan, subMenu: GreaterLessThanMenu },
    { url: "/class-two/number-math/patterns", title: "Patterns", component: Patterns, subMenu: PatternMenu },
    { url: "/class-two/number-math/money", title: "Money", component: Money, subMenu: MoneyMenu },
    // { url: "/class-two/number-math/shapes", title: "Shapes" },
    // { url: "/class-two/number-math/clock", title: "Clock" },
    // { url: "/class-two/number-math/calender", title: "Calender" },
    // { url: "/class-two/number-math/fraction", title: "Fraction" },
    // { url: "/class-two/number-math/arrangement", title: "Arrangement" },
    // { url: "/class-two/number-math/measurement", title: "Measurement" },
    // { url: "/class-two/number-math/temperature", title: "Temperature" },
    { url: "/class-two/number-math/data-handling", title: "Data Handling", component: DataHandling, subMenu: DataHandlingMenu },
];


export default topics;